// extracted by mini-css-extract-plugin
var _1 = "ChapterPathFindMyAvatarButton__avatar--GVEAg";
export { _1 as "avatar" }
